export default "__VITE_ASSET__67610729__"